import applicationSettingsService from '@/api/applicationsettings'
import { APPLICATION_SETTINGS } from '../types'

export default {
  namespaced: true,
  state: {
    applicationSettings: {},
    apiVersion: ''
  },
  getters: {
    applicationSettings (state) {
      return state.applicationSettings
    },
    apiVersion (state) {
      return state.apiVersion
    }
  },
  mutations: {
    [APPLICATION_SETTINGS.SET_APPLICATION_SETTINGS] (state, applicationSettings) {
      state.applicationSettings = applicationSettings
    },
    [APPLICATION_SETTINGS.SET_API_VERSION] (state, version) {
      state.apiVersion = version
    }
  },
  actions: {
    async getApplicationSettings ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await applicationSettingsService.getApplicationSettings()
        commit(APPLICATION_SETTINGS.SET_APPLICATION_SETTINGS, response.data.configurations)
        commit(APPLICATION_SETTINGS.SET_API_VERSION, response.data.apiVersion)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      } 
    },
    async addApplicationSetting ({dispatch}, setting) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await applicationSettingsService.addApplicationSetting(setting)
        await dispatch('getApplicationSettings')
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      }
      catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
        if (error.response && error.response.status === 409) {
          let errors = error.response.data.error.errors[0]
          switch (errors.reason) {
            case 'configurationWithDuplicatedKey':
              dispatch('Global/showMessage', 'conflictKeyAlreadyExists', {root: true})
              break
            default: break
          }
        }
      }
    },
    async updateApplicationSetting ({dispatch}, setting) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await applicationSettingsService.updateApplicationSetting(setting)
        await dispatch('getApplicationSettings')
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      }
      catch (error) {
        dispatch('Global/hideLoading', null, {root: true})
        if (error.response && error.response.status === 409) {
          let errors = error.response.data.error.errors[0]
          switch (errors.reason) {
            case 'configurationWithDuplicatedKey':
              dispatch('Global/showMessage', 'conflictKeyAlreadyExists', {root: true})
              break
            default: break
          }
        }
      }
    }
  }
}
